import { CompanyMaterialSufficiency } from '../modules/materials-usage/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { MaterialSufficiencyView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyMaterialSufficiencyScreen({
  view,
  onView,
}: {
  view: MaterialSufficiencyView;
  onView: ViewSetter<MaterialSufficiencyView>;
}) {
  const { can, timeZone } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('materials_usage.read')}>
      <CompanyMaterialSufficiency timeZone={timeZone} view={view} onView={onView} />
    </GatedCompanyScreen>
  );
}
